export const ENTITY_TYPE = {
    ACCOUNT: 'ACCOUNT',
    ACCOUNT_RAW_DB_CHANGE: 'ACCOUNT_RAW_DB_CHANGE',
    CAMPAIGN: 'CAMPAIGN',
    CAMPAIGN_GROUP: 'CAMPAIGN_GROUP',
    CAMPAIGN_RAW_DB_CHANGE: 'CAMPAIGN_RAW_DB_CHANGE',
    CREATIVE: 'CREATIVE',
    NOTIFICATION_EVENT: 'NOTIFICATION_EVENT',
    TABOOLA_ADS_UI: 'TABOOLA_ADS_UI',
};

export const COMPARISON_OPERATOR = {
    ALWAYS_FALSE: 'ALWAYS_FALSE',
    ALWAYS_TRUE: 'ALWAYS_TRUE',
    EQUALS_TO: 'EQUALS_TO',
    IS_NOT_NULL: 'IS_NOT_NULL',
    IS_NULL: 'IS_NULL',
    REGEX: 'REGEX',
};

export const LOGICAL_OPERATOR = {
    ACCEPT_ALL: 'ACCEPT_ALL',
    AND: 'AND',
    OR: 'OR',
    REJECT_ALL: 'REJECT_ALL',
};

export const FIELD_NAME = {
    ACCOUNT_COUNTRY: 'ACCOUNT_COUNTRY',
    ACCOUNT_CURRENT_MEDIA_SALES_REP: 'ACCOUNT_CURRENT_MEDIA_SALES_REP',
    ACCOUNT_FINANCIAL_CONTACT_EMAIL: 'ACCOUNT_FINANCIAL_CONTACT_EMAIL',
    ACCOUNT_FINANCIAL_CONTACT_NAME: 'ACCOUNT_FINANCIAL_CONTACT_NAME',
    ACCOUNT_FINANCIAL_REP: 'ACCOUNT_FINANCIAL_REP',
    ACCOUNT_ID: 'ACCOUNT_ID',
    ACCOUNT_IS_ACTIVE: 'ACCOUNT_IS_ACTIVE',
    ACCOUNT_IS_MANUAL_FROZEN: 'ACCOUNT_IS_MANUAL_FROZEN',
    ACCOUNT_LANGUAGE: 'ACCOUNT_LANGUAGE',
    ACCOUNT_MEDIA_SALES_REP: 'ACCOUNT_MEDIA_SALES_REP',
    ACCOUNT_NAME: 'ACCOUNT_NAME',
    ACCOUNT_RAW_HISTORY: 'ACCOUNT_RAW_HISTORY',
    ACCOUNT_TIMEZONE: 'ACCOUNT_TIMEZONE',
    APPROVED_CREDIT_LIMIT: 'APPROVED_CREDIT_LIMIT',
    CAMPAIGNS_GROUP_NAME: 'CAMPAIGNS_GROUP_NAME',
    CAMPAIGNS_GROUP_PO_NUMBER: 'CAMPAIGNS_GROUP_PO_NUMBER',
    CAMPAIGNS_GROUP_STATUS: 'CAMPAIGNS_GROUP_STATUS',
    CAMPAIGNS_GROUP_THIRD_PARTY_TRACKING_VENDOR: 'CAMPAIGNS_GROUP_THIRD_PARTY_TRACKING_VENDOR',
    CAMPAIGN_APPROVAL_STATE: 'CAMPAIGN_APPROVAL_STATE',
    CAMPAIGN_BID_STRATEGY: 'CAMPAIGN_BID_STRATEGY',
    CAMPAIGN_BRANDING_TEXT: 'CAMPAIGN_BRANDING_TEXT',
    CAMPAIGN_COMMENTS: 'CAMPAIGN_COMMENTS',
    CAMPAIGN_CPA_GOAL: 'CAMPAIGN_CPA_GOAL',
    CAMPAIGN_CPC: 'CAMPAIGN_CPC',
    CAMPAIGN_DAILY_CAP: 'CAMPAIGN_DAILY_CAP',
    CAMPAIGN_END_DATE: 'CAMPAIGN_END_DATE',
    CAMPAIGN_IS_ACTIVE: 'CAMPAIGN_IS_ACTIVE',
    CAMPAIGN_NAME: 'CAMPAIGN_NAME',
    CAMPAIGN_POLICY_REVIEW: 'CAMPAIGN_POLICY_REVIEW',
    CAMPAIGN_PRICING_MODEL: 'CAMPAIGN_PRICING_MODEL',
    CAMPAIGN_RAW_HISTORY: 'CAMPAIGN_RAW_HISTORY',
    CAMPAIGN_SPENDING_LIMIT: 'CAMPAIGN_SPENDING_LIMIT',
    CAMPAIGN_SPENDING_LIMIT_MODEL: 'CAMPAIGN_SPENDING_LIMIT_MODEL',
    CAMPAIGN_START_DATE: 'CAMPAIGN_START_DATE',
    CAMPAIGN_STATUS: 'CAMPAIGN_STATUS',
    CREDIT_LIMIT: 'CREDIT_LIMIT',
    CREDIT_LIMIT_MODEL: 'CREDIT_LIMIT_MODEL',
    CRM_ID: 'CRM_ID',
    CURRENCY: 'CURRENCY',
    ITEM_APPROVAL_STATE: 'ITEM_APPROVAL_STATE',
    ITEM_DESCRIPTION: 'ITEM_DESCRIPTION',
    ITEM_IS_ACTIVE: 'ITEM_IS_ACTIVE',
    ITEM_POLICY_REVIEW: 'ITEM_POLICY_REVIEW',
    ITEM_STATUS: 'ITEM_STATUS',
    ITEM_THUMBNAIL_URL: 'ITEM_THUMBNAIL_URL',
    ITEM_URL: 'ITEM_URL',
    LEGAL_ENTITY: 'LEGAL_ENTITY',
    MEDIA_ACCOUNT_MANAGER_REP: 'MEDIA_ACCOUNT_MANAGER_REP',
    NOTIFICATION_EVENT_DESCRIPTION: 'NOTIFICATION_EVENT_DESCRIPTION',
    NOTIFICATION_EVENT_EMAILS: 'NOTIFICATION_EVENT_EMAILS',
    PREPAYMENT: 'PREPAYMENT',
    TABOOLA_ADS_UI_ACTION_VALUE: 'TABOOLA_ADS_UI_ACTION_VALUE',
    TABOOLA_ADS_UI_APP_ID: 'TABOOLA_ADS_UI_APP_ID',
    TABOOLA_ADS_UI_EVENT_TYPE: 'TABOOLA_ADS_UI_EVENT_TYPE',
    TABOOLA_ADS_UI_FE_VERSION: 'TABOOLA_ADS_UI_FE_VERSION',
    TABOOLA_ADS_UI_GW_VERSION: 'TABOOLA_ADS_UI_GW_VERSION',
    TABOOLA_ADS_UI_OPERATION_DETAILS: 'TABOOLA_ADS_UI_OPERATION_DETAILS',
    TABOOLA_ADS_UI_RRAND: 'TABOOLA_ADS_UI_RRAND',
    TABOOLA_ADS_UI_SESSION_ID: 'TABOOLA_ADS_UI_SESSION_ID',
    TABOOLA_ADS_UI_SESSION_URL: 'TABOOLA_ADS_UI_SESSION_URL',
    TABOOLA_ADS_UI_TAB_ID: 'TABOOLA_ADS_UI_TAB_ID',
};

export const CRITERIA = {
    NEW_VALUE_CRITERIA: 'New Value',
    OLD_VALUE_CRITERIA: 'Old Value',
};

export const PUSH_API_STATUS = {
    APPROVED: 'APPROVED',
    PENDING: 'PENDING',
    TERMINATED: 'TERMINATED',
};

/** Given a push API status, returns whether it's active */
export const isPushApiStatusActive = status => status === PUSH_API_STATUS.APPROVED;

/** Given a push API status, returns whether it's terminated */
export const isPushApiStatusTerminated = status => status === PUSH_API_STATUS.TERMINATED;

export const criteriaOptions = Object.entries(CRITERIA).map(([key, value]) => ({
    value: CRITERIA[key],
    label: value,
}));

export const entityOptions = Object.entries(ENTITY_TYPE).map(([key, value]) => ({
    value: ENTITY_TYPE[key],
    label: value,
}));

export const comparisonOperatorOptions = Object.entries(COMPARISON_OPERATOR).map(([key, value]) => ({
    value: COMPARISON_OPERATOR[key],
    label: value,
}));

export const logicalOperatorOptions = Object.entries(LOGICAL_OPERATOR).map(([key, value]) => ({
    value: LOGICAL_OPERATOR[key],
    label: value,
}));

export const fieldOptions = Object.entries(FIELD_NAME).map(([key, value]) => ({
    value: FIELD_NAME[key],
    label: value,
}));
